import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconGenerationCasual = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <path
        d="M11.5363 8.99087L2.47554 12.1131C2.23526 12.1957 1.97201 12.1796 1.74366 12.0681C1.51531 11.9567 1.34056 11.7592 1.25782 11.519L1.10001 11.066C0.644629 9.74432 0.732928 8.29589 1.34548 7.03933C1.95804 5.78277 3.04467 4.82102 4.36633 4.36563C5.68799 3.91025 7.13642 3.99855 8.39298 4.61111C9.64954 5.22366 10.6113 6.31029 11.0667 7.63195L11.5363 8.99087Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.537 8.99023L14.5774 10.0968C14.7424 10.1611 14.8864 10.2698 14.9933 10.4109C15.1002 10.552 15.166 10.72 15.1833 10.8963C15.2005 11.0725 15.1687 11.25 15.0912 11.4092C15.0136 11.5684 14.8935 11.7031 14.7442 11.7982C13.6006 12.504 12.289 12.8911 10.9455 12.9193C9.60189 12.9475 8.27523 12.6158 7.10306 11.9585L5.53906 11.0551"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.36719 4.36621C4.36719 4.36621 7.05691 5.83118 7.83891 10.2651"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconGenerationCasual.displayName = 'IconGenerationCasual';
